/**
 * domain
 *
 * @author Shigq
 * @date 2021/5/21 15:51
 */
import { commonUtils } from '@libs/utils'
import { compositions } from '@libs/ui'

const modules = {}

const assembleRemote = () => {
  Object.keys(compositions).forEach((key) => {
    modules[key] = compositions[key]
  })
}

const assembleLocal = () => {
  const files = require.context('./modules', false, /\.js$/)

  files.keys().forEach((key) => {
    const moduleKey = commonUtils.toHump(key).replace(/(\.\/|\.js)/g, '') + 'Comp'
    const moduleValues = files(key).default

    if (modules[moduleKey]) {
      const currentModule = modules[moduleKey]()
      Object.keys(moduleValues()).forEach(innerKey => {
        currentModule[innerKey] = moduleValues()[innerKey]
      })
      modules[moduleKey] = () => { return currentModule }
    } else {
      modules[moduleKey] = moduleValues
    }
  })
}

/**
 * init
 *
 * @description remote composition`s properties will be override by local
 */
const init = () => {
  assembleRemote()
  assembleLocal()
}

init()

// console.log('modules', modules)

module.exports = modules
